<template>
    <v-container v-if="products">
        <v-card class="elevation-10">
            <v-card-title v-if="order">
                Order confirmations
                <v-spacer></v-spacer>
                <v-btn
                    color="blue"
                    dark
                    :href="BASE + 'order/' +  id + '?download_token=' + download_token"
                    target="_blank"
                >
                    Download order confirmation
                </v-btn>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog_upload" persistent max-width="600px">

                    <v-btn slot="activator" color="blue darken-4" dark v-if="order.status.id == 1">Upload signed Order Confirmation</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">Upload files:</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 s12 md12 class="mt-4">
                                        <vue-dropzone v-if="dialog_upload" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="confirmOrder()" @vdropzone-error="showError"></vue-dropzone>
                                    </v-flex>
                                    <v-flex xs12 s12 md12 v-if="document_error">
                                        <v-alert
                                            :value="true"
                                            color="error"
                                            icon="warning"
                                            outline
                                        >
                                            {{ document_error }}
                                        </v-alert>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click="dialog_upload = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-spacer></v-spacer>
                <v-btn color="secondary" class="black--text">{{ order.status.name }}</v-btn>
                <v-spacer></v-spacer>
            </v-card-title>

            <FilesComponent :order_id="id"></FilesComponent>
        </v-card>
    </v-container>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import FilesComponent from './components/FilesComponent';
    import { BASE } from '../../../config';
    import { API_BASE } from '../../../config';

    export default {
        props: ['id'],
        data: function () {
            return {
                BASE: BASE,
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: false,
                headers: [
                    {
                        text: 'Code',
                        align: 'left',
                        sortable: false,
                        value: 'code'
                    },
                    { text: 'Product', value: 'product', sortable: false },
                    { text: 'Units', value: 'units', sortable: false },
                    { text: 'Price(Kg)', value: 'pricekg', sortable: false },
                    { text: 'Price', value: 'price', sortable: false },
                    { text: 'Creation date', value: 'date', sortable: false }
                ],
                products: null,
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                order: null,
                dialog_upload: null,
                dropzoneOptions: {
                    url: API_BASE + 'orders/' + this.id + '/signed',
                    thumbnailWidth: 150,
                    maxFilesize: 500,
                    headers: {
                        'Authorization': localStorage.getItem('token'),
                        'Autrollization': localStorage.getItem('token'),
                        'Authorization-temp': localStorage.getItem('token')
                    },
                    addRemoveLinks: true,
                    maxFiles: 1
                },
                download_token: null,
                document_error: null
            }
        },
        created () {
            this.getProducts();
            this.getOrderDetail();
            this.debouncedGetProducts = _.debounce(this.getProducts, 500);
            this.checkUser();
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetProducts();
            },
            last_page: function () {
                if (this.page > this.products.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods: {
            showError(file, message, xhr) {
                this.document_error = message;
            },
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            confirmOrder () {
                this.$store.dispatch('confirmOrder', {
                    id: this.id
                }).then((res) => {
                    this.getOrderDetail();
                    this.document_error = null;
                    this.dialog_upload = false;
                }).catch((error) => {

                });
            },
            getOrderDetail () {
                this.$store.dispatch('getOrderDetail', {
                    id: this.id
                }).then((res) => {

                    this.order = res.data;

                }).catch((error) => {

                });
            },
            setPage (page) {
                this.page = page;
                this.getOrders();
            },
            getProducts () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        id: this.id
                    }
                };
                this.$store.dispatch('getProducts', params).then((res) => {

                    this.products = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },

        },
        components : {
            FilesComponent,
            vueDropzone: vue2Dropzone
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/agent/orders/DetailComponent.vue